import {
    exportarHelper,
    useBuscarHelper
} from "../../../Commons/Scripts/Utils/webservice-helper.js";
import {URL_EXPORTAR_TIENDA_DATAGRID} from "../../../Facturacion/Scripts/Utils/constantes"; 

const URL_BUSCAR_TARJETAS = "/Activos/WebService/ActivosWebService.asmx/BuscarBancoDashboardTarjetas";

const URL_BUSCAR_GRAFICO_TASA_CHEQUE_RECHAZO = "/Activos/WebService/ActivosWebService.asmx/BuscarGraficoTasaChequeRechazo";
const URL_BUSCAR_GRAFICO_TASA_SOLICITUD_PAGO_RECHAZO = "/Activos/WebService/ActivosWebService.asmx/BuscarGraficoTasaSolicitudPagoRechazado";
const URL_BUSCAR_GRAFICO_TASA_SOLICITUD_PAGO_APROBADO = "/Activos/WebService/ActivosWebService.asmx/BuscarGraficoTasaSolicitudPagoAprobado";
const URL_BUSCAR_GRAFICO_DIFERENCIA_CAMBIARIA_PERDIDA = "/Activos/WebService/ActivosWebService.asmx/BuscarGraficoPerdidDiferenciaCambiaria";
const URL_BUSCAR_GRAFICO_DIFERENCIA_CAMBIARIA_GANANCIA = "/Activos/WebService/ActivosWebService.asmx/BuscarGraficoGananciaDiferenciaCambiaria";
const URL_BUSCAR_GRAFICO_SOLICITUDES_PAGO_POR_ESTATUS = "/Activos/WebService/ActivosWebService.asmx/BuscarGraficoSolicitudesPagosPorEstatus";

const URL_BUSCAR_CUENTAS_BANCO_GRID = "/Activos/WebService/ActivosWebService.asmx/BuscarCuentasBancoGridDashboard";
const URL_BUSCAR_CUENTAS_BANCO_AUTOCOMPLETE = "/Activos/WebService/ActivosWebService.asmx/BuscarListadoCuentasBanco";
const URL_EXPORTAR_CUENTAS_BANCO_GRID = "/Activos/WebService/ActivosWebService.asmx/ExportarCuentasBancoGridDashboard";

export const useBuscarCuentasBancoAutoComplete = (cuerpo) => {
  const url = URL_BUSCAR_CUENTAS_BANCO_AUTOCOMPLETE;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return {data, loading, error};   
}

export const useObtenerGridCuentasBancoDashboard = (cuerpo) => {
  const url = URL_BUSCAR_CUENTAS_BANCO_GRID;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return {data, loading, error};   
}

export const useBuscarGraficoSolicitudesPagoPorEstatusDashboard = (cuerpo) => {
  const url = URL_BUSCAR_GRAFICO_SOLICITUDES_PAGO_POR_ESTATUS;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return {data, loading, error};   
}

export const useBuscarGraficoTasaChequeRechazoDashboard = (cuerpo) => {
  const url = URL_BUSCAR_GRAFICO_TASA_CHEQUE_RECHAZO;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return {data, loading, error};   
}
export const useBuscarGraficoTasaSolicitudPagoRechazoDashboard = (cuerpo) => {
  const url = URL_BUSCAR_GRAFICO_TASA_SOLICITUD_PAGO_RECHAZO;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return {data, loading, error};   
}
export const useBuscarGraficoTasaSolicitudPagoAprobadoDashboard = (cuerpo) => {
  const url = URL_BUSCAR_GRAFICO_TASA_SOLICITUD_PAGO_APROBADO;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return {data, loading, error};   
}
export const useBuscarGraficoDiferenciaCambiariaPerdidaDashboard = (cuerpo) => {
  const url = URL_BUSCAR_GRAFICO_DIFERENCIA_CAMBIARIA_PERDIDA;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return {data, loading, error};   
}
export const useBuscarGraficoDiferenciaCambiariaGananciaDashboard = (cuerpo) => {
  const url = URL_BUSCAR_GRAFICO_DIFERENCIA_CAMBIARIA_GANANCIA;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return {data, loading, error};   
}

export const useBuscarTarjetasDashboard = (cuerpo) => {
    const url = URL_BUSCAR_TARJETAS;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }

export const exportarCuentasBancoGrid = async (cuerpo) => {

    try {
        await exportarHelper(URL_EXPORTAR_CUENTAS_BANCO_GRID, cuerpo);
    } catch (error) {
        console.error("Falló la descarga del reporte:", error);
        alert("Ocurrió un error al generar el reporte. Por favor, intente de nuevo.");
    } finally {
        // Oculta el indicador de carga
        // document.getElementById('spinner').style.display = 'none';
    }
}